import ReactGA from "react-ga4";

const analytics = ReactGA;

analytics.initialize("G-4F0DHXQPPQ");

export default analytics;
